import React from 'react';

export const authRouteConfig = [
  // {
  //   routes: [
  //     {
  //       path: '/signin',
  //       component: React.lazy(() => import('./Signin')),
  //     },
  //   ],
  // },
  // {
  //   routes: [
  //     {
  //       path: '/signup',
  //       component: React.lazy(() => import('./Signup')),
  //     },
  //   ],
  // },
  // {
  //   routes: [
  //     {
  //       path: '/confirm-signup',
  //       component: React.lazy(() => import('./ConfirmSignupAwsCognito')),
  //     },
  //   ],
  // },
  // {
  //   routes: [
  //     {
  //       path: '/reset-password',
  //       component: React.lazy(() => import('./ResetPasswordAwsCognito')),
  //     },
  //   ],
  // },
  // {
  //   routes: [
  //     {
  //       path: '/forget-password',
  //       component: React.lazy(() => import('./ForgetPassword')),
  //     },
  //   ],
  // },
  // {
  //   routes: [
  //     {
  //       path: '/error-pages/error-404',
  //       component: React.lazy(() => import('../errorPages/Error404/index')),
  //     },
  //   ],
  // },
  {
    routes: [
      {
        path: '/error-pages/invalidLink',
        component: React.lazy(() => import('../errorPages/InvalidLink/index')),
      },
    ],
  },
  {
    //homepage
    routes: [
      {
        path: '/home',
        component: React.lazy(() => import('./Home/index')),
      },
    ],
  },
  {
    //myOrder
    routes: [
      {
        path: '/order',
        component: React.lazy(() => import('./Home/Orders/index')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/orderView',
        component: React.lazy(() => import('./Home/Orders/OrderDetails/index')),
      },
    ],
  },
  // {
  //   //User Verification
  //   routes: [
  //     {
  //       path: '/userInfo',
  //       component: React.lazy(() => import('./UserPage/index')),
  //     },
  //   ],
  // },
  {
    //ComingSoon
    routes: [
      {
        path: '/comingsoon',
        component: React.lazy(() => import('./ComingSoon/index')),
      },
    ],
  },
  // {
  //   //newOrder
  //   routes: [
  //     {
  //       path: '/neworder',
  //       component: React.lazy(() => import('./Home/OrderView/index')),
  //     },
  //   ],
  // },
  // {
  //   //failOrder
  //   routes: [
  //     {
  //       path: '/failorder',
  //       component: React.lazy(() => import('./Home/OrderView/failOrderView')),
  //     },
  //   ],
  // },
];
